// extracted by mini-css-extract-plugin
module.exports = {"header":"MainNavigation_header__1RQyo","logo":"MainNavigation_logo__2nuKe","nav":"MainNavigation_nav__1rBjL","active":"MainNavigation_active__2yub8"};